import { bindActionCreators } from 'redux'
import * as login from '../../common/actions/login'
import * as language from '../../common/actions/language'
import * as modal from '../../common/actions/modal'

export default dispatch => ({
  login: bindActionCreators(login, dispatch),
  language: bindActionCreators(language, dispatch),
  modal: bindActionCreators(modal, dispatch)
})
